import styled, { keyframes } from 'styled-components';
import { PrintingModal } from '../../utils/complexDocumentConstants';

export const rightSlide = keyframes`
  100% {
    transform: translateX(0);
    opacity: 1;
  }
`;

export const leftSlide = keyframes`
  100% {
    transform: translateX(0);
    opacity: 1;
  }
`;

const popIn = keyframes`
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

export const ApprovalContainer = styled.div`
  flex: 1;
  height: 100%;
  display: flex;
  gap: 1%;
  @media (max-width: 980px) {
    flex-direction: column;
  }

  .ant-collapse {
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE 10+ */
  }
  .ant-collapse-content {
    transition: all 0.8s !important;
  }
  .ant-collapse-content-box {
    max-height: ${({contentType})=> contentType !== PrintingModal ? 460 : 550}px;
    overflow-y: auto;
    scrollbar-width: none;
  }
  .ant-collapse-header {
    font-size: 15px;
    font-family: 'Lato';
  }

  @media (min-width: 1024px) and (max-height: 700px) {
    max-height: 500px;
  }
`;

export const Sider = styled.div`
  max-height: 550px;
  height:550px;
  width: 30%;
  scrollbar-width: none;
  transform: translateX(-15%);
  opacity: 0;
  animation: ${rightSlide} 1s forwards;
  animation-delay: 0.3s;
  ::-webkit-scrollbar {
    display: none;
  }
  @media (max-width: 980px) {
    width: 100%;
    overflow: unset;
  }
`;

export const Content = styled.div`
  .ant-spin {
    padding-block: 30px;
  }
  .ant-spin-dot-item {
    background: #32de84;
  }
  .ant-spin.ant-spin-show-text .ant-spin-text {
    padding-block: 12px;
    color: #000;
  }
  margin-top: 20px;
  width: 70%;
  font-family: 'Lato', sans-serif;
  display: flex;
  flex-direction: column;
  max-height: 550px;
  height:550px;
  // overflow: auto;
  ::-webkit-scrollbar {
    display: none;
  }
  @media (max-width: 980px) {
    width: 100%;
    height: 100%;
  }

  .table-wrapper {
    scrollbar-width: none;
    ::-webkit-scrollbar {
      display: none;
    }
    height: 100%;
    transform: translateX(5%);
    opacity: 0;
    animation: ${leftSlide} 1s forwards;
    animation-delay: 0.3s;
    @media (max-width: 1024px) {
      height: 90%;
    }
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  height: 13%;
  align-items: center;
  transform: scale(0.9);
  opacity: 0;
  animation: ${popIn} 1s forwards;
  animation-delay: 0.3s;
  visibility: ${props => props.visibility && 'hidden'};
`;

export const StyledTimeline = styled.div`
  display: flex;
  justify-content: center;
  margin: 35px 0 15px 0;
`;

export const TimelineContainer = styled.div`
.wave-anim-point {
  height: 8px;
  width: 8px; 
  background: #66ffc2;
  border-radius: 50%;
  position: relative;
}
.wave {
  position: absolute;
  top: 50%;
  left: 50%;
  height: 8px;
  width: 8px;
  background: #ccffeb;
  z-index: -1;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  animation: animate 2s ease-in-out infinite;
}
@keyframes animate {
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    height: 25px;
    width: 25px;
  }
}
  @keyframes drawLine {
    100% {
      width: 220px;
    }
  }
  @keyframes drawLineVertical {
    100% {
      height: 40px;
    }
  }
  @keyframes popInAnim {
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }
  @keyframes iconAnimation {
    100% {
      opacity: 1;
      transform: translateX(-50%) scale(1);
    }
  }
  @keyframes slideInAnim {
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
      transform: translate(0);
    }
  }
  position: relative;
  width: 0;
  border-top: 1px solid #ccc;
  animation: drawLine 0.5s 0.5s ease-in-out forwards;
  .iconContainer {
    position: absolute;
    top: 0%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
  }
  .iconWrapper {
    position: absolute;
    top: -50%;
    left: 50%;
    z-index: 1;
    opacity: 0;
    transform: translateX(-50%) scale(0);
    animation: iconAnimation 0.5s ${props => 0.8 + (0.7 * (props.level - 1))}s ease-in-out forwards;
    svg {
      width: 17px;
    }
  }
  .levelInfo {
    font-size: 11px;
    font-weight: bold;
    text-transform: uppercase;
    background: #f1f1f1;
    padding: 4px 12px;
    border-radius: 24px;
    transform: scale(0);
    animation: popInAnim 0.5s 0.9s ease-in-out forwards;
  }
  .dashedVerticalLine {
    height: 0;
    border-left: 1px dashed lightgray;
    animation: drawLineVertical 0.5s ${props => 1.2 + (0.7 * (props.level - 1))}s ease-in-out forwards;
  }
  .timelineInfo {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    div {
      width: fit-content;
      max-width: 95%;
      text-align: center;
      border-radius: 6px;
    }
  }
  h4 {
    font-size: 13px;
    text-transform: uppercase;
    font-weight: 700;
    padding: 6px 8px;
    text-underline-position: under;
    opacity: 0;
    transform: translateY(-100%);
    animation: slideInAnim 0.3s ${props => 1.5 + (0.6 * (props.level - 1))}s ease-in-out forwards;
  }
  .timeInfo {
    font-size: 11px;
    padding: 2px 4px;
    opacity: 0;
    transform: translateY(-100%);
    animation: slideInAnim 0.3s ${props => 1.6 + (0.6 * (props.level - 1))}s ease-in-out forwards;
  }
  .userInfo {
    font-size: 13px;
    color: #000;
    padding: 2px 4px;
    text-transform: uppercase;
    opacity: 0;
    transform: translateY(-100%);
    animation: slideInAnim 0.3s ${props => 1.7 + (0.6 * (props.level - 1))}s ease-in-out forwards;
  }
`;